import React from "react";
import { usePaymentStore } from "../../stores/StoreContext";
import { ExternalWalletPayment } from "../defaultPaymentCard/ExternalWalletPayment";

type props = {};

export const PaymentOptions: React.FC<props> = () => {
  const paymentStore = usePaymentStore();
  return paymentStore.isPaymentThroughExternalWallet() ? (
    <div style={{ marginTop: 30 }}>
      <ExternalWalletPayment />
    </div>
  ) : null;
};
